var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExtrasMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75777 13.4666C7.78444 11.6133 9.75777 10.5199 10.9044 8.87992C12.1178 7.15992 11.4378 3.94659 7.99777 3.94659C5.74444 3.94659 4.63777 5.65325 4.17111 7.06659L0.717773 5.61325C1.66444 2.77325 4.23777 0.333252 7.98444 0.333252C11.1178 0.333252 13.2644 1.75992 14.3578 3.54659C15.2911 5.07992 15.8378 7.94659 14.3978 10.0799C12.7978 12.4399 11.2644 13.1599 10.4378 14.6799C10.1044 15.2933 9.97111 15.6933 9.97111 17.6666H6.11777C6.10444 16.6266 5.94444 14.9333 6.75777 13.4666ZM10.6644 22.9999C10.6644 24.4666 9.46444 25.6666 7.99777 25.6666C6.53111 25.6666 5.33111 24.4666 5.33111 22.9999C5.33111 21.5333 6.53111 20.3333 7.99777 20.3333C9.46444 20.3333 10.6644 21.5333 10.6644 22.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtrasMenu);
export default __webpack_public_path__ + "static/media/icon_extras_menu.61b09ef55e629a51e9d183b8899a760a.svg";
export { ForwardRef as ReactComponent };